<template>
  <main class="home-page container p-4 text-sp-primary">
    <section class="text-center my-8">
      <p>{{ $t("formUnavailable") }}</p>
      <a href="https://support-hwa.nexters.com/hc"
        class="underline underline-offset-2 hover:text-sp-accent duration-150"
        target="_blank"
      >
        {{ $t("helpCenter") }}
      </a>
    </section>
  </main>
</template>
